import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiService, User } from '@/lib/api';
import { useUserStore } from '@/store/userStore';

export function useCheckUser(lineId: string | null) {
  const { setCurrentUser } = useUserStore();
  
  return useQuery({
    queryKey: ['user', lineId],
    queryFn: async () => {
      const user = await apiService.checkUser(lineId!);
      setCurrentUser(user);
      return user;
    },
    enabled: !!lineId,
  });
}

export function useRegisterUser() {
  const queryClient = useQueryClient();
  const { setCurrentUser } = useUserStore();
  
  return useMutation({
    mutationFn: apiService.registerUser,
    onSuccess: (newUser) => {
      queryClient.setQueryData(['user', newUser.lineUUID], newUser);
      setCurrentUser(newUser);
    },
  });
}

export function useUpdateUser() {
  const queryClient = useQueryClient();
  const { setCurrentUser } = useUserStore();
  
  return useMutation({
    mutationFn: ({ userId, userData }: { userId: string; userData: Parameters<typeof apiService.updateUser>[1] }) => 
      apiService.updateUser(userId, userData),
    onSuccess: (updatedUser) => {
      queryClient.setQueryData(['user', updatedUser.lineUUID], updatedUser);
      setCurrentUser(updatedUser);
    },
  });
}